import React, { useState, useEffect, useLayoutEffect, useCallback } from 'react';
import styled, { css } from 'styled-components';

import { getColorForIcons } from './styleFunctions';

const Line = styled.div`
  position: absolute;
  width: ${(props) => props.length}px;
  height: 3px;
  background-color: ${(props) => getColorForIcons(props.status)};
  top: ${(props) => props.top}px;
  left: ${(props) => props.left}px;
  transform: rotate(${(props) => props.angle}deg);
  transform-origin: 0 0;

  ${({ isLastLine }) =>
    isLastLine &&
    css`
      ::before,
      ::after {
        content: '';
        position: absolute;
        height: 100%;
      }

      ::before {
        width: 50%;
        color: ${({ theme }) => theme.communityList.highlightedItem};
      }

      ::after {
        width: 50%;
        left: 50%;
        border-top: 4px dashed ${({ theme }) => theme.communityList.highlightedItem};
      }
    `}
`;

const ConnectingLine = ({ startElementId, endElementId, parentContainerId, status, isLastLine, isMobile }) => {
  const [lineCoordinates, setLineCoordinates] = useState({ length: 0, angle: 0, top: 0, left: 0 });

  const updateLinePosition = useCallback(() => {
    const startElement = document.getElementById(startElementId);
    const endElement = document.getElementById(endElementId);
    const container = document.getElementById(parentContainerId);
    const moduleContainer = document.getElementById(`module-container-${parentContainerId}`);

    if (startElement && endElement && container) {
      const hasPracticeButton = moduleContainer.contains(document.getElementById('practice-button'));
      const startRect = startElement.getBoundingClientRect();
      const endRect = endElement.getBoundingClientRect();
      const containerRect = container.getBoundingClientRect();

      const x1 = endRect.left - containerRect.left + endRect.width / 2;
      const y1 = endRect.top - containerRect.top + endRect.height / 2;
      const x2 = startRect.left - containerRect.left + startRect.width / 2;
      const y2 = startRect.top - containerRect.top + startRect.height / 2;

      let length = Math.sqrt((x2 - x1) ** 2 + (y2 - y1) ** 2);
      if (isLastLine) length = hasPracticeButton ? length - 65 : length - 60;
      const angle = Math.atan2(y2 - y1, x2 - x1) * (180 / Math.PI);
      let top = hasPracticeButton ? y1 + 65 : y1 + 60;
      if (isMobile) top -= 10;
      const left = x1;

      setLineCoordinates({ length, angle, top, left, status, isLastLine });
    }
  }, [startElementId, endElementId, parentContainerId, status, isLastLine, isMobile]);

  useLayoutEffect(() => {
    updateLinePosition();
  }, [updateLinePosition]);

  useEffect(() => {
    const handleResize = () => updateLinePosition();
    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, [updateLinePosition]);

  return <Line {...lineCoordinates} />;
};

export default ConnectingLine;
